import { Organization } from 'models/organization';
import { ProfileLanguage, ProfileText, SupplierProfile } from 'models/organization-profile';
import { ProfileMedia } from './general-profile-tab.component';
import { hasProfileText, labProfileLanguage } from './profile-texts';

export const EMPTY_SUPPLIER_PROFILE: SupplierProfile = { visible: false, services: [], otherService: '', texts: [] };

export const labLanguageOf = (lab: Organization): ProfileLanguage =>
    labProfileLanguage(lab.localeFormat?.language, lab.contact?.address?.country);

export const mediaOf = (lab: Organization): ProfileMedia => ({
    logoImage: lab.logoImage || '',
    staffImage: lab.staffImage || '',
    logoSignedUrl: lab.logoSignedUrl || '',
    staffSignedUrl: lab.staffSignedUrl || '',
    hexCode: lab.hexCode || '',
    textCode: lab.textCode || '',
});

/** A lab saved before DD-3662 has only the single-language fields: read them as its own language. */
export const clinicTextsOf = (lab: Organization, labLanguage: ProfileLanguage): ProfileText[] => {
    if (lab.profileTexts?.length) {
        return lab.profileTexts.map(({ language, shortDescription, longDescription }) => ({
            language,
            shortDescription,
            longDescription,
        }));
    }
    return hasProfileText(lab.shortDescription, lab.longDescription)
        ? [{ language: labLanguage, shortDescription: lab.shortDescription, longDescription: lab.longDescription }]
        : [];
};

export const supplierProfileOf = (lab: Organization): SupplierProfile => {
    const profile = lab.supplierProfile;
    if (!profile) return EMPTY_SUPPLIER_PROFILE;
    return {
        visible: profile.visible,
        services: [...profile.services],
        otherService: profile.otherService ?? '',
        texts: profile.texts.map(({ language, description }) => ({ language, description })),
    };
};
